// ReviewSummaryChart.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BarChart } from '@mui/x-charts/BarChart';
import sliderConfig from '../../config/sliderConfig';
import { transformReviewDataToDataset } from '../../utils/chartDataTransform';
import { Box, Paper } from '@mui/material';


const ReviewSummaryChart = ({ aggregatedReviewDataByPosition  }) => {
    const [selectedPosition, setSelectedPosition] = useState('All');

    /// Transform data
    const datasets = transformReviewDataToDataset(aggregatedReviewDataByPosition, sliderConfig);

    // Pick the dataset for the selected position
    const dataset = selectedPosition === 'All'
                    ? Object.values(datasets).flat()
                    : datasets[selectedPosition] || [];


    dataset.sort((a, b) => b.value - a.value);

    // Chart settings
    const chartSetting = {
        xAxis: [{ tick: false }],
        height: 400,
    };

    const valueFormatter = (value) => `${value}%`; // Assuming values are percentages

    // Extract the global color from the CSS variable
    const globalColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--slider-value-color').trim() || '#007bff'; // Default to #007bff if not found

    return (
        <Box sx={{width: '100%'}}>

            <select value={selectedPosition} onChange={e => setSelectedPosition(e.target.value)}>
                <option value="All">All Positions</option>
                {/* Populate with actual positions */}
            </select>

            <Paper sx={{width: '100%', height: 'auto', overflow: 'auto'}} elevation={3}>
                {dataset.length > 0 ? (
                    <BarChart
                        dataset={dataset}
                        yAxis={[{scaleType: 'band', dataKey: 'category'}]}
                        series={[{
                            dataKey: 'value',
                            label: 'Aggregated Reviews',
                            valueFormatter,
                        }]}
                        layout="horizontal"
                        colors={[globalColor]}
                        {...chartSetting}
                    />
                ) : (
                    <Box p={2} textAlign="center">No review data yet.</Box>
                )}
            </Paper>
        </Box>
    );
};

ReviewSummaryChart.propTypes = {
    aggregatedReviewDataByPosition: PropTypes.object.isRequired,
};

export default ReviewSummaryChart;
